<!--
//================================================================================
// ID:BC005
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC005
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/19 | 富士通株式会社         | 新規作成
// 01.02.00 | 2022/10/06 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.05.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div>
		<div class="contents__main">
			<div class="div-right">
				<a href="https://www.metro.tokyo.lg.jp/index.html" class="margin__right-2per" :tabindex="85" target="_blank">
					都庁総合ホームページ
				</a>
			</div>
			<error-message />
			<div v-if="!isAuthenticated" class="contents__information div-tyuimargin">
				<div>
					<font-awesome-icon icon="exclamation-triangle" />
					<label class="label-tyuijikou">注意事項</label>
				</div>
				<div>
					<p class="toroku-tyui">
						都営住宅募集への申込みには
						<router-link
							v-on:click.native="clickRiyoToroku()"
							:to="{}"
							tabindex="-1">
							利用者登録
						</router-link>
						が必要です。
					</p>
					<p class="toroku-tyui">
						利用者登録が完了していない場合、申込みのときに、再度住宅検索が必要になります。
					</p>
				</div>
			</div>
			<div v-if="isAuthenticated" class="favorite-button margin__bottom-20">
				<a
					class="contents__btn-favorite-search contents__favorite"
					@click="clickOkiniiriSearchBtn"
					tabindex="1">
					お気に入り登録した住宅一覧へ
				</a>
				<br/>
				<label class="contents__caution">これまでにお気に入り登録（<font-awesome-icon :icon="['fas', 'heart']" />をチェック）した住宅のみを表示します</label>
				<br/>
			</div>
			<h2 class="contents__h2">検索条件</h2>
			<section>
				<table class="contents__table--stripe detail">
					<tbody>
						<tr class="contents__input--tr">
							<th class="contents__input--title bosyu-title">
								募集の種類<span class="contents__hissu">必須</span>
							</th>
							<td class="padding__bottom-10">
								<div class="margin__left-20">
									<list-box
										class="contents__input--select width-bosyu"
										:modelValue="form.bosyuKind"
										:name="'募集の種類'"
										:groupId="'bosyuKindInfo'"
										:listItems="disp.kbBosyuList"
										:requireFlg="true"
										:disabledFlg="disp.bosyuKindDisabledFlg"
										:cdKbn="CD_HANDLE_TYPE.MIX_CD_HANYO1"
										@update:modelValue="changeBosyuList"
										ref="bosyuKind"
										tabindex="2">
										<requestFocus />
									</list-box>
									<itemerror-message :groupId="'bosyuKindInfo'"/>
								</div>
								<div class="bosyu-message">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.bosyuTyui1Items"
									/>
								</div>
								<div class="bosyu-message">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.bosyuTyui2Items"
									/>
								</div>
								<div class="bosyu-message">
									<caution-message
										:classDiv="'font-size'"
										:tyuibunItems="disp.bosyuTyui3Items"
										:replaceItems="disp.bosyuTyui3Params"
									/>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr">
							<th class="contents__input--title bosyu-title">
								住宅の種別<span class="contents__hissu">必須</span>
							</th>
							<td class="padding__bottom-10">
								<div class="margin__left-20">
									<list-box
										class="contents__input--select width-jyutaku"
										:modelValue="form.jyutakuKind"
										:name="'住宅の種別'"
										:groupId="'jyutakuKindInfo'"
										:listItems="disp.jyutakuKindList"
										:requireFlg="true"
										:reducedDisplayFlg="true"
										@update:modelValue="changeJyutakuList"
										ref="jyutakuKind"
										tabindex="3" />
									<itemerror-message :groupId="'jyutakuKindInfo'"/>
								</div>
								<div class="contents__caution--div margin__left-20 padding__bottom-m7">
									<div class="line__height-20">
										<caution-message
											:classDiv="'font-size'"
											:cdHanyo1="'T0009'"
											:cdHanyo2="disp.jyutakuKind"
											:replaceItems="disp.jyutakuTyuiParams"
										/>
									</div>
								</div>
								<div v-if="form.jyutakuKind == '22'" class="contents__caution--div margin__left-20 padding__bottom-m7 margin__top-m5">
									<div class="line__height-20">
										<caution-message
											:classDiv="'font-size'"
											:tyuibunItems="disp.jyutakuTyui2"
										/>
									</div>
								</div>
							</td>
						</tr>
						<tr></tr>
						<tr>
							<th class="contents__input--title nyukyo-title">
								都営住宅に入居する人数<span class="contents__hissu">必須</span>
							</th>
							<td class="padding__bottom-10 background__color--white">
								<div class="margin__left-20">
									<number-input
										class="width-nyukyo"
										:modelValue="form.nyukyoNinzu"
										:maxLength="2"
										:name="'入居予定人数'"
										:groupId="'nyukyoNinzuInfo'"
										:requireFlg="true"
										:numberType="NUMBERINPUT_TYPE.INTEGER"
										@update:modelValue="inputNyukyoNinzu"
										ref="nyukyoNinzu"
										tabindex="4"
									/>人
									<itemerror-message :groupId="'nyukyoNinzuInfo'"/>
								</div>
								<div>
									<div class="margin__left-20">
										<caution-message
											:classDiv="'font-size'"
											:tyuibunItems="disp.ninzuTyui1Items"
										/>
									</div>
									<div v-if="disp.ninzuTyui2Flg" class="margin__left-20">
										<caution-message
											:classDiv="'font-size'"
											:tyuibunItems="disp.ninzuTyui2Items"
										/>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<h2 class="contents__h2">検索条件の追加</h2>
				<table class="contents__table--stripe detail">
					<tbody>
						<tr class="width-kushicho-title">
							<th class="contents__input--title margin__bottom-m25">区市町</th>
							<td>
								<div class="margin__left-20">
									<label class="contents__caution">※区市町を選択してください。</label>
								</div>
								<div class="margin__left-20">
									<label class="contents__caution">※複数選択が可能です。</label>
								</div>
								<div id="kubuLayer" class="width-kubu-title">
									<check-box
										:classDiv="'font-size-16 kaigyousinai'"
										:modelValue="disp.kubuZenSentaku"
										:name="'区部全選択・全解除'"
										:listItems="disp.kubuZenSentakuList"
										@update:modelValue="disp.kubuZenSentaku = $event"
										ref="kubu"
										tabindex="5"
										:disabledFlg="disp.kubuZenSentakuFlg" />
									<div v-if="disp.mobileFlg" class="square-position float__right" @click="kubuOpen()">
										<transition name="rotate" mode="out-in">
											<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isKubuOpen" key="rotate1"/>
											<font-awesome-icon :icon="['far', 'plus-square']" v-else key="rotate2"/>
										</transition>
									</div>
								</div>
								<transition name="open">
									<div class="content" v-if="disp.isKubuOpen">
										<label v-if="disp.kubuMsgFlg" class="padding__left-3per font-size-16">申込み可能な住宅はありません</label>
										<div class="cond__checkbox margin__left--select-all">
											<check-box
												:classDiv="'width-kubu'"
												:modelValue="form.kubu"
												:cdType="'L0013'"
												:cdHanyo1="'1'"
												:name="'区部'"
												:enabledItems="disp.kubuList"
												:groupId="'kubuInfo'"
												:classItem="'width-kushibu-range'"
												@update:modelValue="changeKubu"
												ref="kubu"
												tabindex="6" />
											<itemerror-message :groupId="'kubuInfo'"/>
										</div>
									</div>
								</transition>
								<div id="shibuLayer" class="width-shibu-title margin__top-5">
									<check-box
										:classDiv="'font-size-16 kaigyousinai'"
										:modelValue="disp.shibuZenSentaku"
										:name="'市部全選択・全解除'"
										:listItems="disp.shibuZenSentakuList"
										@update:modelValue="disp.shibuZenSentaku = $event"
										ref="shibu"
										tabindex="30" 
										:disabledFlg="disp.shibuZenSentakuFlg"/>
									<div v-if="disp.mobileFlg" class="square-position float__right" @click="shibuOpen()">
										<transition name="rotate" mode="out-in">
											<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isShibuOpen" key="rotate1"/>
											<font-awesome-icon :icon="['far', 'plus-square']" v-else key="rotate2"/>
										</transition>
									</div>
								</div>
								<transition name="open">
									<div v-if="disp.isShibuOpen">
										<label v-if="disp.shibuMsgFlg" class="padding__left-3per font-size-16">申込み可能な住宅はありません</label>
										<div class="cond__checkbox margin__left--select-all">
											<check-box
												:classDiv="'width-shibu'"
												:modelValue="form.shibu"
												:cdType="'L0013'"
												:cdHanyo1="'2'"
												:name="'市部'"
												:enabledItems="disp.shibuList"
												:groupId="'shibuInfo'"
												:classItem="'width-kushibu-range'"
												@update:modelValue="changeShibu"
												ref="shibu"
												tabindex="31" />
											<itemerror-message :groupId="'shibuInfo'"/>
										</div>
									</div>
								</transition>
							</td>
						</tr>
						<tr v-if="disp.mobileFlg" id="fitLayer" class="width-filter-title">
							<th class="contents__filter--title" colspan="2">
								<label class="filter padding__left-3per font-size-16">さらに条件を絞り込む</label>
								<div class="square-position2 float__right" @click="filterOpen()">
									<transition name="rotate" mode="out-in">
										<font-awesome-icon :icon="['far', 'minus-square']" v-if="disp.isFilterOpen" key="rotate3"/>
										<font-awesome-icon :icon="['far', 'plus-square']" v-else key="rotate4"/>
									</transition>
								</div>
							</th>
							<td class="isPC-non-display"></td>
						</tr>
						<tr v-else class="isMOBILE-non-display">
							<th></th>
						</tr>
						<tr class="width-jyutakuname-title background__color--light-gray" v-if="disp.isFilterOpen">
							<th class="contents__input--title margin__bottom-m18">住宅名</th>
							<td>
								<div class="jyutakuname-title margin__left-20">
									<text-input
										class="width-jyutakuname"
										:modelValue="form.jyutakuName"
										:maxLength="30"
										:name="'住宅名'"
										:groupId="'jyutakuNameInfo'"
										:placeholder="'（フリーワード）'"
										@update:modelValue="form.jyutakuName = $event"
										@blur="getSelectedCount"
										ref="jyutakuName"
										tabindex="57" />
									<itemerror-message :groupId="'jyutakuNameInfo'"/>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--white" v-if="disp.isFilterOpen">
							<th class="contents__input--title width-trans-title">主な交通機関</th>
							<td class="border__bottom-none">
								<div class="width-trans-item">
									<text-input
										class="contents__input--text width-trans1"
										:modelValue="form.trans1"
										:maxLength="70"
										:name="'主な交通機関１'"
										:groupId="'transInfo'"
										:placeholder="'（フリーワード）'"
										@update:modelValue="form.trans1 = $event"
										@blur="getSelectedCount"
										ref="trans1"
										tabindex="58" />
									<text-input
										class="contents__input--text width-trans2"
										:modelValue="form.trans2"
										:maxLength="70"
										:name="'主な交通機関２'"
										:groupId="'transInfo'"
										:placeholder="'（フリーワード）'"
										@update:modelValue="form.trans2 = $event"
										@blur="getSelectedCount"
										ref="trans2"
										tabindex="59" />
									<text-input
										class="contents__input--text width-trans3"
										:modelValue="form.trans3"
										:maxLength="70"
										:name="'主な交通機関３'"
										:groupId="'transInfo'"
										:placeholder="'（フリーワード）'"
										@update:modelValue="form.trans3 = $event"
										@blur="getSelectedCount"
										ref="trans3"
										tabindex="60" />
									<itemerror-message :groupId="'transInfo'"/>
								</div>
								<div class="width-trans-tyui">
									<label class="contents__caution">※路線、駅、バス停等を入力してください。</label>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr" v-if="disp.isFilterOpen">
							<th class="contents__input--title"></th>
							<td class="margin__top-m20">
								<div class="width-keyword">
									<radio-button
										:modelValue="form.keyword"
										:listItems="disp.keywordList"
										:name="'キーワードを含む'"
										:radioGroupName="'keyword'"
										:cdKbn="CD_HANDLE_TYPE.ID_CD"
										:disabledFlg="false"
										@update:modelValue="changeKeyword"
										ref="keyword"
										tabindex="61"
									/>
								</div>
								<div class="width-tohomin-title">駅・バス停からの徒歩分
									<list-box
										class="contents__input--select width-tohomin"
										:modelValue="form.tohoMin"
										:name="'徒歩時間'"
										:groupId="'tohoMinInfo'"
										:cdType="'L0033'"
										@update:modelValue="changeTohoMin"
										ref="tohoMin"
										tabindex="62" />
									<itemerror-message :groupId="'tohoMinInfo'"/>
								</div>
								<div class="cond__checkbox width-busJyogai-title">
									<check-box
										:modelValue="form.busJyogai"
										:name="'バス利用除外'"
										:groupId="'busJyogaiInfo'"
										:listItems="disp.busJyogaiList"
										@update:modelValue="changeBusJyogai"
										ref="busJyogai"
										tabindex="63" />
									<itemerror-message :groupId="'busJyogaiInfo'"/>
								</div>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="background__color--light-gray">
							<th class="contents__input--title margin__bottom-m18">間取り</th>
							<td>
								<div class="cond__checkbox width-madori-item">
									<check-box
										:classDiv="'width-madori'"
										:modelValue="form.madori"
										:cdType="'L0020'"
										:name="'間取り'"
										:groupId="'madoriInfo'"
										:classItem="'width-madori-range'"
										@update:modelValue="changeMadori"
										ref="madori"
										tabindex="64" />
									<itemerror-message :groupId="'madoriInfo'"/>
								</div>
								<div class="width-madori-tyui">
									<label class="contents__caution">※複数選択が可能です。</label>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr" v-if="disp.isFilterOpen">
							<th class="contents__input--title width-senyoarea-title">専用面積(m&sup2;)</th>
							<td>
								<div class="width-senyoarea-item">
									<list-box
										class="contents__input--select width-senyoarea"
										:modelValue="form.senyoAreaFrom"
										:name="'専用面積（From）'"
										:groupId="'senyoAreaInfo'"
										:cdType="'L0047'"
										:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
										:blankFlg="false"
										@update:modelValue="changeSenyoAreaFrom"
										ref="senyoAreaFrom"
										tabindex="76" />
									m&sup2;&nbsp;～
									<list-box
										class="contents__input--select width-senyoarea"
										:modelValue="form.senyoAreaTo"
										:name="'専用面積（To）'"
										:groupId="'senyoAreaInfo'"
										:cdType="'L0051'"
										:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
										:blankFlg="false"
										@update:modelValue="changeSenyoAreaTo"
										ref="senyoAreaTo"
										tabindex="77" />
									m&sup2;&nbsp;
									<itemerror-message :groupId="'senyoAreaInfo'"/>
								</div>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="background__color--light-gray">
							<th class="contents__input--title margin__bottom-m18">建設年度からの<br/>経過年数</th>
							<td>
								<div class="margin__left-20">
									<list-box
										class="contents__input--select width-buildyears"
										:modelValue="form.buidYears"
										:name="'建設年度からの経過年数'"
										:groupId="'buidYearsInfo'"
										:cdType="'L0014'"
										:cdKbn="CD_HANDLE_TYPE.MIX_HANYO21"
										@update:modelValue="changeBuidYears"
										ref="buidYears"
										tabindex="78" />
									<itemerror-message :groupId="'buidYearsInfo'"/>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr" v-if="disp.isFilterOpen">
							<th class="contents__input--title elevator-title">エレベーター</th>
							<td>
								<div class="cond__checkbox margin__left-20">
									<check-box
										:classDiv="'width-elevator'"
										:modelValue="form.elevator"
										:name="'エレベーター'"
										:groupId="'elevatorInfo'"
										:listItems="disp.elevatorList"
										@update:modelValue="changeElevator"
										ref="elevator"
										tabindex="79" />
									<itemerror-message :groupId="'elevatorInfo'"/>
								</div>
								<div class="contents__caution--div">
									<div class="contents__caution--div width-elevaotr-tyui">
										<div>
											<p class="contents__caution contents__caution--multiple">
												<caution-message
													:classDiv="'font-size'"
													:tyuibunItems="disp.elevatorTyuiItems"
												/>
											</p>
										</div>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen" class="background__color--white background__color--light-gray">
							<th class="contents__input--title barrierfree-title">バリアフリー</th>
							<td>
								<div class="cond__checkbox width-barrierfree-item">
									<check-box
										:classDiv="'width-barrierFree'"
										:modelValue="form.barrierFree"
										:name="'バリアフリー'"
										:groupId="'barrierFreeInfo'"
										:listItems="disp.barrierFreeList"
										@update:modelValue="changeBarrierFree"
										ref="barrierFree"
										tabindex="80"
									/>
									<itemerror-message :groupId="'barrierFreeInfo'"/>
								</div>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen && disp.kbYuguDispFlg">
							<th class="contents__input--title yugu-title">優遇抽せん</th>
							<td>
								<div class="cond__checkbox margin__left-20">
									<check-box
										:classDiv="'width-yugu'"
										:modelValue="form.yugu"
										:listItems="disp.yuguList"
										:name="'優遇抽せんの有無'"
										:groupId="'yuguInfo'"
										:cdKbn="CD_HANDLE_TYPE.ID_CD"
										:disabledFlg="form.kbYuguFlg"
										@update:modelValue="changeYugu"
										ref="yugu"
										tabindex="81"
									/>
									<itemerror-message :groupId="'yuguInfo'"/>
								</div>
								<div class="contents__caution--div margin__left-20">
									<div class="width-245">
										<caution-message
											:classDiv="'font-size'"
											:tyuibunItems="disp.yuguTyuiItems"
										/>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="disp.isFilterOpen && disp.bairituDispFlg" :class="[{'background__color--light-gray': disp.kbYuguDispFlg}, {'background__color--white': !disp.kbYuguDispFlg}]">
							<th class="contents__input--title bairitu-title">参考倍率</th>
							<td>
								<div class="width-bairitu-item">
									<list-box
										class="contents__input--select width-bairitu"
										:modelValue="form.bairitu"
										:name="'参考倍率'"
										:groupId="'bairituInfo'"
										:cdType="'L0048'"
										:cdKbn="CD_HANDLE_TYPE.CD_HANYO1"
										:disabledFlg="form.bairituFlg"
										@update:modelValue="changeBairitu"
										ref="bairitu"
										tabindex="83" />
									<itemerror-message :groupId="'bairituInfo'"/>
								</div>
								<div class="contents__caution--div">
									<div class="contents__caution--div width-bairitu-tyui">
										<caution-message
											:classDiv="'font-size height-bairitu-tyui'"
											:tyuibunItems="disp.bairituTyuiItems"
										/>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<h2 v-if="disp.isZenBairituDispFlg" class="contents__h2">参考情報</h2>
				<table v-if="disp.isZenBairituDispFlg" class="contents__table--stripe detail">
					<tbody>
						<tr class="contents__input--tr">
							<th class="contents__input--title">前回募集の応募倍率</th>
							<td class="width-zenBairituTyui"> 
								<div class="contents__caution--div margin-zenBairituTyui">
									<div>
										<caution-message
											:classDiv="'font-size'"
											:tyuibunItems="disp.ZenBairituTyuiItems"
											:linkUrlItems="disp.zenkaiLinkItems"
										/>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br/>
				<div class="search-button">
					<input type="submit" value="検索" class="contents__btn--normal" tabindex="84" @click="clickSearchBtn" :disabled="disp.searchBtnDisabledFlg">
				</div>
				<br/>
				<div class="margin__bottom-page">
					<p class="Copyright-align">Copyright (C) 2022 Tokyo Metropolitan Government. All Rights Reserved.</p>
				</div>
			</section>
		</div>
		<div class="contents__counterbar">
			<dl>
				<dt>該当件数</dt>
				<dd>
					<span class="contents__counterbar--counter">{{ co_commaSeparated(disp.selectedCnt) }}</span>
				</dd>
				<dt>件</dt>
			</dl>
		</div>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import ListBox from '@/components/ListBox.vue';
import CheckBox from '@/components/CheckBox.vue';
import RadioButton from '@/components/RadioButton.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_isMobile, co_isOperation } from '@/common/browserUtility.js'; 
import { co_isEmpty, co_checkHalfNumber } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTop, co_toTrans } from '@/common/screenUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { API_CHECKBOX_ITEMS } from '@/const/route.js';


import { NUMBERINPUT_TYPE, CD_HANDLE_TYPE, DIALOG_BUTTON_LIST_KEY, HTTP_STATUS } from '@/const/const.js';
import { PATH_BC005_INIT, PATH_BC005_GET_YUSOUEND, PATH_BC005_GET_TYUIPARAM, PATH_BC005_GET_KUSHIBU,
			PATH_BC005_COUNT, PATH_BC005_COUNT_OKINIIRI, PATH_BC005_GET_JYUTAKUINFO } from '@/const/route.js';
import { STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_ERROR_SETMSG, STORE_DATA_ADD_DATA, STORE_DATA_GETDATA, STORE_ENV_GET_LIST_MAX_COUNT,
			STORE_VIEW_PROGRESS, STORE_USER_IS_AUTHENTICATED, STORE_ERROR_SET_INPUT_ERR, STORE_VIEW_CLEAR_PAGE } from '@/const/store.js';

export default {
	name: "BC005",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'list-box': ListBox,
		'check-box': CheckBox,
		'radio-button': RadioButton,
		'caution-message' : CautionMessage,
		'itemerror-message': ItemErrorMessage
	},
	data: function () {
		return {
			form: {
				bosyuKind: '',					// 募集の種類
				jyutakuKind: '',				// 住宅の種別
				nyukyoNinzu: '',				// 入居人数
				jyutakuName: '',				// 住宅名
				kubu: '',						// 区部（チェックされたもの）
				shibu: '',						// 支部（チェックされたもの）
				kushicyoList: [],				// 区市町リスト
				trans1: '',						// 主な交通機関１
				trans2: '',						// 主な交通機関２
				trans3: '',						// 主な交通機関３
				transList: [],					// 主な交通機関リスト
				keyword: '1',					// キーワードを含む
				tohoMin: '',					// 徒歩時間
				busJyogai: '',					// バス利用の住戸を除く
				madori: '',						// 間取り
				madoriList: [],					// 間取りリスト
				senyoAreaFrom: '',				// 専用面積（From）
				senyoAreaTo: '',				// 専用面積（To）
				buidYears: '',					// 建設年度からの経過年数
				buildYearsCd: '',				// 建設年度からの経過年数コード
				elevator: '',					// エレベーター
				barrierFree: '',				// バリアフリー
				kbYuguFlg: true,				// 優遇抽せんの制御フラグ
				yugu: '',						// 優遇抽せんの有無
				yuguList: [],					// 優遇抽せんの有無リスト
				bairituFlg: false,				// 参考倍率の制御フラグ
				bairitu: '',					// 参考倍率
				hanyoCode: '',					// 汎用コード
				zikoUmu: '',					// 住居内で病死等があった住宅の有無
				isOkiniiriSearch: false,		// お気に入り検索フラグ（true：お気に入り検索、false：通常検索）
				isAuthenticated: false,			// ログイン認証済みフラグ
				kbMosikomiStatus: '0',			// 住宅変更時、世帯情報の申込み状況（0:申込み未、1:一時保存、2:申込み済）
			},
			disp: {
				jyutakuDataCount: 0,			// 募集住宅情報対象件数
				kbBosyuList: [],				// 募集の種類マスタデータリスト
				jyutakuDataList: [],			// 住宅の種別マスタデータリスト
				jyutakuKindList: [],			// 住宅の種別リスト
				bosyuTyui1Items: ['C0003'],		// 募集の種類注意文リスト１
				bosyuTyui2Items: [],			// 募集の種類注意文リスト２
				bosyuTyui3Items: [],			// 募集の種類注意文リスト３
				bosyuTyui3Params: [],			// 募集の種類注意文パラメータ３
				jyutakuTyuiParams: [],			// 住宅の種別注意文パラメータ
				jyutakuTyui2: [],				// 住宅の種別注意文２
				ninzuTyui1Items: ['C0011'],		// 入居予定人数注意文１リスト
				ninzuTyui2Items: ['C0206'],		// 入居予定人数注意文２リスト
				keywordList: [],				// キーワードを含むリスト
				busJyogaiList: [],				// バス利用除外
				elevatorList: [],				// エレベーターリスト
				elevatorTyuiItems: ['C0033'],	// エレベーター注意文リスト
				barrierFreeList: [],			// バリアフリーリスト
				yuguList: [],					// 優遇抽せんの有無リスト
				yuguTyuiItems: ['C0015'],		// 優遇抽せん注意文リスト
				bairituTyuiItems: ['C0014'],	// 参考倍率注意文リスト
				ZenBairituTyuiItems: ['C0078'],	// 前回募集の応募倍率注意文リスト
				wsize: 0,						// ウインドウサイズ
				isKubuOpen: true,				// 区部開閉フラグ
				isShibuOpen: true,				// 支部開閉フラグ
				isFilterOpen: true,				// 絞り込み開閉フラグ
				mobileFlg : false,				// モバイル端末フラグ
				ninzuTyui2Flg : false,			// 入居予定人数注意文２フラグ
				kbYuguDispFlg: true,			// 優遇抽せんの画面表示フラグ
				kbYuguTempFlg: true,			// 優遇抽せんの画面表示退避フラグ
				jyutakuKind: '',				// 住宅の種別
				zenkaiLinkItems: [],			// 前回募集の平均倍率のリンク先リスト
				bosyuKindDisabledFlg: false,	// 募集の種類活性・非活性フラグ
				searchBtnDisabledFlg: false,	// 検索ボタン活性・非活性フラグ
				kubuList: [],					// 区部リスト（活性状態のもの）
				shibuList: [],					// 市部リスト（活性状態のもの）
				kubuMsgFlg: false,              // 区部メッセージフラグ
				shibuMsgFlg: false,             // 市部メッセージフラグ
				isZenBairituDispFlg: true,		// 前回募集の応募倍率画面表示フラグ
				bosyuHoshiki: 0,				// 募集方式（1：毎月募集、2：定期募集（抽選方式）、3：定期募集（ポイント方式）、4：随時募集）
				bairituDispFlg: true,			// 参考倍率の画面表示フラグ
				kubuZenSentakuList: [],			// 区部の全選択のチェックボックスの設定
				shibuZenSentakuList: [],		// 市部の全選択のチェックボックスの設定
				kubuZenSentaku: "",				// 区部の一括選択・解除チェックボックスのチェックフラグ
				shibuZenSentaku: "",			// 市部の一括選択・解除チェックボックスのチェックフラグ
				kubuZenSentakuFlg: false,		// 区部の一括選択・解除チェックボックスの非活性フラグ（trueの場合非活性）
				shibuZenSentakuFlg: false,		// 市部の一括選択・解除チェックボックスの非活性フラグ（trueの場合非活性）
				kubuZenSentakuZikkouFlg: true,	// 区部の一括選択・解除チェックボックスの実行フラグ（trueの場合実行）
				shibuZenSentakuZikkouFlg: true,	// 市部の一括選択・解除チェックボックスの実行フラグ（trueの場合実行）
				selectedCnt: 0,					// 検索該当件数
				jyutakuList: [],				// 募集住宅一覧リスト(該当件数表示用)
				isClacSelectedCnt: true,		// 検索該当件数計算実行フラグ
			},
			co_commaSeparated: co_commaSeparated,
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE
		}
	},
	created: async function() {

		// ブラウザチェック
		if(!await co_isOperation()) {
			co_toTrans('BrowserError');
		}

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// キーワード項目設定
		this.disp.kubuZenSentakuList = [{ idCd: '1', nmCd: '区部' }];

		// キーワード項目設定
		this.disp.shibuZenSentakuList = [{ idCd: '1', nmCd: '市部' }];


		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		this.disp.mobileFlg = await co_isMobile();
		if(this.disp.mobileFlg) {
			this.disp.isKubuOpen = false;
			this.disp.isShibuOpen = false;
			this.disp.isFilterOpen = false;
		}

		// 住宅の種別初期情報取得
		let initData = await co_post(PATH_BC005_INIT);
		this.disp.jyutakuDataCount = initData.bosyuKensu;
		this.disp.kbBosyuList = initData.kbBosyuList;
		this.disp.jyutakuDataList = initData.jyutakuDataList;

		if (this.disp.jyutakuDataCount == 0) {
			co_errorDialog(co_getMessage('E0058'), this.callBack);
		}

		// 前回の検索条件確認
		let data = this.$store.getters[STORE_DATA_GETDATA]('BC005');
		let disp = this.$store.getters[STORE_DATA_GETDATA]('BC005DISP');
		if (data != null) {

			// 検索条件設定
			this.form = data;
			let code = this.form.bosyuKind.substring(2);
			let list = this.disp.jyutakuDataList.filter(x => x.kbBosyuKbn == code);
			let jyutakuKindList = new Array();
			for (let i = 0; i < list.length; i++) {
				jyutakuKindList.push({ idCd: list[i].kbZyutaku, nmCd: list[i].nmZyutaku });
			}
			this.disp.jyutakuKindList = jyutakuKindList;

			// 区市部絞り込み
			await this.searchKushibu();

		} else {
			// 専用面積初期値設定
			this.form.senyoAreaFrom = '0';
			this.form.senyoAreaTo = '99';

			// 住宅の種類初期値設定
			this.disp.jyutakuKindList = new Array();
		}

		if (disp != null) {
			// 募集の種類注意文２、募集の種類注意文３、住宅の種別注意文設定
			this.disp.bosyuTyui2Items = disp.bosyuTyui2Items;
			this.disp.bosyuTyui3Items = disp.bosyuTyui3Items;
			this.disp.bosyuTyui3Params = disp.bosyuTyui3Params;
			this.disp.jyutakuTyuiParams = disp.jyutakuTyuiParams;
			this.disp.jyutakuKind = disp.jyutakuKind;
			this.disp.zenkaiLinkItems = disp.zenkaiLinkItems;
			// 入居予定人数注意文２フラグ
			this.disp.ninzuTyui2Flg = disp.ninzuTyui2Flg;
			// 優遇抽せんの画面表示フラグ
			this.disp.kbYuguTempFlg = disp.kbYuguTempFlg;
			this.disp.kbYuguDispFlg = disp.kbYuguDispFlg;
			if (this.disp.kbYuguTempFlg == false) {
				this.disp.kbYuguDispFlg = this.disp.kbYuguTempFlg;
				this.disp.kbYuguTempFlg = true;
			}
			// 前回募集の応募倍率画面表示フラグ
			this.disp.isZenBairituDispFlg = disp.isZenBairituDispFlg;
			// 区市部絞り込み
			this.disp.kubuList = disp.kubuList;
			this.disp.shibuList = disp.shibuList;
			this.disp.kubuMsgFlg = disp.kubuMsgFlg;
			this.disp.shibuMsgFlg = disp.shibuMsgFlg;
		}

		let bc008Data = this.$store.getters[STORE_DATA_GETDATA]('BC008');
		if (bc008Data != null) {
			// 世帯情報入力からの遷移の場合
			if (bc008Data.cdStatus != null && bc008Data.cdStatus == '2' ) {
				// 受付済みの場合、募集の種類を非活性にする。
				this.disp.bosyuKindDisabledFlg = true;
			}

			// 一時保存または受付済みの場合、「随時募集」への変更不可
			let code = this.form.jyutakuKind
			if (bc008Data.noRenzoku != '') {
				this.disp.kbBosyuList = this.disp.kbBosyuList.filter(x => x.idCd != '25');
				code = bc008Data.kbZyutaku;

				// 募集の種類が選択済でかつ随時募集が選択されている場合、募集の種類を未選択とする。
				if (!co_isEmpty(this.form.bosyuKind) && this.form.bosyuKind.substring(0,2) == '25') {
					this.form.bosyuKind = '';
				}
			}

			this.disp.bosyuHoshiki = this.getBosyuHoshiki(code);
			if (this.form.bosyuKind == '' || bc008Data.cdStatus != '2') {
				if (this.form.bosyuKind == '') {
					this.form.bosyuKind = bc008Data.kbBosyu;
					this.changeBosyuList(this.form.bosyuKind);
					this.form.jyutakuKind = bc008Data.kbZyutaku;
					this.form.nyukyoNinzu = String(bc008Data.nuNyukyo);
					this.changeJyutakuList(this.form.jyutakuKind);
				}
			} else {
				let jyutakuKindList = new Array();
				let list = new Array();
				if (this.disp.bosyuKindDisabledFlg) {
					// 募集方式と募集の種類の区分が同じもののみ選択可とする。
					let code = this.form.bosyuKind.substring(2);
					list = this.disp.jyutakuDataList.filter(x => x.bosyuHoshiki == this.disp.bosyuHoshiki && x.kbBosyuKbn == code);
				} else {
					list = this.disp.jyutakuDataList.filter(x => x.bosyuHoshiki == this.disp.bosyuHoshiki);
				}

				for (let i = 0; i < list.length; i++) {
					jyutakuKindList.push({ idCd: list[i].kbZyutaku, nmCd: list[i].nmZyutaku });
				}
				this.disp.jyutakuKindList = jyutakuKindList;

				// 区市部絞り込み
				this.searchKushibu();
			}

			// お気に入り検索制御
			if (bc008Data.cdStatus != null && bc008Data.cdStatus == '2' ) {
				// 申込み済
				this.form.kbMosikomiStatus = '2';
			} else if (bc008Data.noRenzoku != '') {
				// 一時保存済み
				this.form.kbMosikomiStatus = '1';
			} else {
				// 上記以外
				this.form.kbMosikomiStatus = '0';
			}
		}

		// キーワード項目設定
		this.disp.keywordList = [
			{ idCd: '1', nmCd: 'いずれかのキーワードを含む'},
			{ idCd: '2', nmCd: 'すべてのキーワードを含む'}
		];
		// バス利用除外項目設定
		this.disp.busJyogaiList = [
			{ idCd: '1', nmCd: 'バス利用の住戸を除く'}
		];
		// エレベーター項目設定
		this.disp.elevatorList = [
			{ idCd: '1', nmCd: '有り'}
		];
		// バリアフリー項目設定
		this.disp.barrierFreeList = [
			{ idCd: '1', nmCd: 'バリアフリー仕様の住宅のみ表示'}
		];
		// 優遇抽せんの有無項目設定
		this.disp.yuguList = [
			{ idCd: '1', nmCd: '優遇抽せんの対象住宅のみ表示'},
			{ idCd: '2', nmCd: '優遇抽せんの対象でない住宅のみ表示'}
		];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	computed: {
		// ログイン認証済みフラグ
		isAuthenticated: function() {
			return this.$store.getters[STORE_USER_IS_AUTHENTICATED];
		}
	},
	mounted: async function () {
		await this.$nextTick();

		// 該当件数取得可
		this.disp.isClacSelectedCnt = true;

		if (!this.disp.mobileFlg) {
			// フォーカス設定
			this.$refs.bosyuKind.focus();
		}

		// ページトップへ遷移
		co_toTop();
	},
	watch: {
		'disp.kubuZenSentaku' : async function() {
			// 区部の「全て選択」のチェックボックスの制御
			if(this.disp.kubuZenSentakuZikkouFlg){
				if (this.disp.kubuZenSentaku == '1') {
					// チェックされた場合、活性状態の区部にチェックをつける。
					if(this.disp.kubuList.length == 0){
						// 区部の活性状態リストに要素が無い場合
						if(this.disp.kubuMsgFlg == false){
							// 検索条件の絞り込みが行われる前の場合（メッセージが表示されていない状態）
							// 初期表示の区部のリストを取得する。
							let params = { cdType: 'L0013', cdHanyo1: '1', cdHanyo2: '', cdHanyo3: ''};
							let data = [];
							data  =  await co_post( API_CHECKBOX_ITEMS, params );
							// 取得した区部を活性状態リストに格納する。
							for (let i = 0; i < data.length; i++) {
								this.disp.kubuList.push(data[i].idCd);
							}
							// 活性状態リストから区部のチェックされたものリストに格納する
							this.form.kubu = this.disp.kubuList.join();
						} else {
							// メッセージが表示されている場合は全て非活性なので何もしない
						}
					} else {
						// 区部の活性状態リストに要素がある場合、チェックされたものリストに格納する。
						this.form.kubu = this.disp.kubuList.join();
					}
				} else {
					// チェックを外した場合、区部のチェックされたものリストを空白にする。
					this.form.kubu = '';
				}
			} else {
				this.disp.kubuZenSentakuZikkouFlg = true;
			}

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		'disp.shibuZenSentaku' : async function() {
			// 市部の「全て選択」のチェックボックスの制御
			if(this.disp.shibuZenSentakuZikkouFlg){
				if (this.disp.shibuZenSentaku == '1') {
					// チェックされた場合、活性状態の市部にチェックをつける。
					if(this.disp.shibuList.length == 0){
						// 市部の活性状態リストに要素が無い場合
						if(this.disp.shibuMsgFlg == false){
							// 検索条件の絞り込みが行われる前の場合（メッセージが表示されていない状態）
							// 初期表示の市部のリストを取得する。
							let params = { cdType: 'L0013', cdHanyo1: '2', cdHanyo2: '', cdHanyo3: ''};
							let data = [];
							data  =  await co_post( API_CHECKBOX_ITEMS, params );
							// 取得した市部を活性状態リストに格納する。
							for (let i = 0; i < data.length; i++) {
								this.disp.shibuList.push(data[i].idCd);
							}
							// 活性状態リストから市部のチェックされたものリストに格納する
							this.form.shibu = this.disp.shibuList.join();
						} else {
							// メッセージが表示されている場合は全て非活性なので何もしない
						}
					} else {
						// 市部の活性状態リストに要素がある場合、チェックされたものリストに格納する。
						this.form.shibu = this.disp.shibuList.join();
					}
				} else {
					// チェックを外した場合、市部のチェックされたものリストを空白にする。
					this.form.shibu = '';
				}
			} else {
				this.disp.shibuZenSentakuZikkouFlg = true;
			}

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		}
	},
	methods: {
		// 「区部」バー開閉処理
		kubuOpen: function () {
			this.disp.isKubuOpen = !this.disp.isKubuOpen;
		},
		// 「市部」バー開閉処理
		shibuOpen: function () {
			this.disp.isShibuOpen = !this.disp.isShibuOpen;
		},
		// 「さらに絞り込む」バー開閉処理
		filterOpen: function () {
			this.disp.isFilterOpen = !this.disp.isFilterOpen;
		},

		// 利用者登録リンク押下
		clickRiyoToroku: function () {
			let param = {callViewId: 'BC005'};
			co_toTrans('BC003', param);
		},
		// コールバック関数
		callBack: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ページトップへ遷移
				co_toTop();

				return;
			}
		},
		
		// 住宅の種別リスト作成
		makeJyutakuList: function() {

			let jyutakuList = new Array();
			for (let i = 0; i < this.disp.jyutakuDataList.length; i++) {
				jyutakuList.push({ idCd: this.disp.jyutakuDataList[i].kbZyutaku, nmCd: this.disp.jyutakuDataList[i].nmZyutaku });
			}
			return jyutakuList;
		},

		// 募集の種類リスト変更
		changeBosyuList: function (val) {
			this.form.bosyuKind = val;

			this.form.jyutakuKind = '';
			this.disp.jyutakuKind = '';
			this.form.kbYuguFlg = true;
			this.form.yugu = '';
			this.form.bairituFlg = true;
			this.form.bairitu = '';
			this.disp.zenkaiLinkItems = [''];
			this.disp.ninzuTyui2Flg = false;
			this.disp.kbYuguDispFlg = true;
			this.disp.isZenBairituDispFlg = true;

			// 募集の種類注意文設定
			this.setBosyuTyuiItems();
			
			let jyutakuKindList = new Array();
			let list = new Array();
			let code = this.form.bosyuKind.substring(2);
			if (this.disp.bosyuKindDisabledFlg) {
				// 募集方式と募集の種類の区分が同じもののみ選択可とする。
				list = this.disp.jyutakuDataList.filter(x => x.bosyuHoshiki == this.disp.bosyuHoshiki && x.kbBosyuKbn == code);
			} else {
				list = this.disp.jyutakuDataList.filter(x => x.kbBosyuKbn == code);
			}
			for (let i = 0; i < list.length; i++) {
				jyutakuKindList.push({ idCd: list[i].kbZyutaku, nmCd: list[i].nmZyutaku });
			}
			this.disp.jyutakuKindList = jyutakuKindList;

			// 該当件数絞り込み用住宅リスト初期化
			this.disp.jyutakuList = new Array();

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 募集の種類注意文設定
		setBosyuTyuiItems: async function() {

			this.disp.bosyuTyui2Items = new Array();
			let code = this.form.bosyuKind.substring(0,2);

			switch(code) {
				case '01':
					this.disp.bosyuTyui2Items.push('C0004');
				break;
				case '02':
					this.disp.bosyuTyui2Items.push('C0037');
				break;
				case '03':
					this.disp.bosyuTyui2Items.push('C0038');
				break;
				case '04':
					this.disp.bosyuTyui2Items.push('C0039');
				break;
				case '05':
					this.disp.bosyuTyui2Items.push('C0040');
				break;
				case '06':
					this.disp.bosyuTyui2Items.push('C0041');
				break;
				case '07':
					this.disp.bosyuTyui2Items.push('C0042');
				break;
				case '08':
					this.disp.bosyuTyui2Items.push('C0043');
				break;
				case '09':
					this.disp.bosyuTyui2Items.push('C0044');
				break;
				case '10':
					this.disp.bosyuTyui2Items.push('C0045');
				break;
				case '11':
					this.disp.bosyuTyui2Items.push('C0046');
				break;
				case '12':
					this.disp.bosyuTyui2Items.push('C0047');
				break;
				case '21':
					this.disp.bosyuTyui2Items.push('C0048');
				break;
				case '22':
					this.disp.bosyuTyui2Items.push('C0049');
				break;
				case '23':
					this.disp.bosyuTyui2Items.push('C0050');
				break;
				case '24':
					this.disp.bosyuTyui2Items.push('C0051');
				break;
				case '25':
					this.disp.bosyuTyui2Items.push('C0205');
				break;
				default:
			}

			let bosyuTyui3Items = new Array();
			if (!co_isEmpty(this.form.bosyuKind) && code != '25')
			{
				let args = {
					'bosyuKind' : this.form.bosyuKind
				};
				let data = await co_post(PATH_BC005_GET_YUSOUEND, args);
				bosyuTyui3Items.push('C0058');
				this.disp.bosyuTyui3Params = [ data.dtYusouEnd ];
			}
			this.disp.bosyuTyui3Items = bosyuTyui3Items;

			// 随時募集を選択した場合の制御
			if (code == '25') {
				// 入居予定人数注意文２を表示させる
				this.disp.ninzuTyui2Flg = true;
				// 前回募集の応募倍率を非表示にする
				this.disp.isZenBairituDispFlg= false;
			}

		},

		// 住宅の種別リスト変更
		changeJyutakuList: async function (val) {
			this.form.jyutakuKind = val;

			let paramNeedList = ['08', '12', '13', '21'];
			this.disp.jyutakuKind = '';
			let args = {
				'bosyuKind' : this.form.bosyuKind,
				'jyutakuKind' : this.form.jyutakuKind
			};
			let param = await co_post(PATH_BC005_GET_TYUIPARAM, args);
			if (paramNeedList.findIndex(item => item === this.form.jyutakuKind) >= 0) {
				this.disp.jyutakuTyuiParams = [ param.dtBosyuStt, param.dtShitamiEnd ];
			}
			this.disp.jyutakuKind = this.form.jyutakuKind;
			this.disp.zenkaiLinkItems = [param.txZenkaiLink];

			let list = new Array();
			if (!co_isEmpty(this.form.jyutakuKind)) {
				list = this.disp.jyutakuDataList.filter(x => x.kbZyutaku == this.form.jyutakuKind);
			} else {
				this.form.jyutakuKind = '';
				this.form.kbYuguFlg = true;
				this.form.yugu = '';
				this.disp.kbYuguDispFlg = true;

				// 検索条件に該当する件数取得
				this.disp.jyutakuList = new Array();
				this.getSelectedCount();

				return;
			}

			let code = this.form.bosyuKind.substring(2);
			if (list[0].kbYuguEnabled == 1 && this.form.nyukyoNinzu > 1) {
				// 優遇抽せんの対象を活性
				this.disp.kbYuguDispFlg = true;
				this.form.kbYuguFlg = false;
			} else if (code == '4' || this.form.jyutakuKind == '20' || this.form.jyutakuKind == '21') {
				// 優遇抽せんを非表示
				this.disp.kbYuguDispFlg = false;
				this.form.yugu = '';
			} else {
				// 優遇抽せんの対象を非活性
				this.disp.kbYuguDispFlg = true;
				this.form.kbYuguFlg = true;
				this.form.yugu = '';
			}

			this.disp.bairituDispFlg = true;
			if (code == '1') {
				// 「募集の種類」が「毎月募集」
				if (this.form.jyutakuKind == '24') {
					// 住宅の種別が「結婚予定者向（定期使用住宅・10年期限付 ※２人以上のみ）」
					// 参考倍率リストを活性
					this.form.bairituFlg = false;
				} else {
					// 上記以外の場合
					// 参考倍率リストを非活性
					this.form.bairituFlg = true;
				}
				this.form.bairitu = '';
			} else if (code == '2' || code == '3') {
				// 「募集の種類」が「定期募集」
				if (list[0].kbZiko == '1') {
					// 住宅の種別が「住居内で病死等があった住宅」
					// 参考倍率リストを非活性
					this.form.bairituFlg = true;
					this.form.bairitu = '';
				} else if ( this.form.jyutakuKind == '08' || this.form.jyutakuKind == '21') {
					// 住宅の種別が「単身者用車いす使用者向住宅（抽せん方式）」、
					//            「世帯向（車いす使用者世帯向住宅・ポイント方式）」
					// 参考倍率リストを非表示
					// this.disp.bairituDispFlg = false;
					this.form.bairituFlg = true;
					this.form.bairitu = '';
				} else {
					// 上記以外の場合
					// 参考倍率リストを活性
					this.form.bairituFlg = false;
					this.form.bairitu = '';
				}
			} else {
				// 「募集の種類」が「随時募集」
				// 参考倍率リストを非表示
				this.disp.bairituDispFlg = false;
				this.form.bairituFlg = true;
				this.form.bairitu = '';
			}

			// 住宅の種別注意文２設定
			this.disp.jyutakuTyui2 = new Array();
			if (this.form.jyutakuKind == '22') {
				// 住宅の種別が随時募集の「世帯向（一般募集住宅）※２人以上の家族向のみ」である場合
				this.disp.jyutakuTyui2.push('C0251');
			}

			// 該当件数絞り込み用住宅リスト初期化
			this.disp.jyutakuList = new Array();

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 入居予定人数入力
		inputNyukyoNinzu: function (val) {
			this.form.nyukyoNinzu = val;

			// 優遇抽せんの対象を活性制御
			let list = new Array();
			if (!co_isEmpty(this.form.jyutakuKind)) {
				list = this.disp.jyutakuDataList.filter(x => x.kbZyutaku == this.form.jyutakuKind);
				let code = this.form.bosyuKind.substring(2);
				if (list[0].kbYuguEnabled == 1 && this.form.nyukyoNinzu > 1) {
					// 優遇抽せんの対象を活性
					this.disp.kbYuguDispFlg = true;
					this.form.kbYuguFlg = false;
				} else if (code == '4' || this.form.jyutakuKind == '20' || this.form.jyutakuKind == '21') {
					// 優遇抽せんを非表示
					this.disp.kbYuguDispFlg =false;
					this.form.yugu = '';
				} else {
					// 優遇抽せんの対象を非活性
					this.disp.kbYuguDispFlg = true;
					this.form.kbYuguFlg = true;
					this.form.yugu = '';
				}
			} else {
				// 優遇抽せんの対象を非活性
				this.disp.kbYuguDispFlg = true;
				this.form.kbYuguFlg = true;
				this.form.yugu = '';
			}

			// 該当件数絞り込み用住宅リスト初期化
			this.disp.jyutakuList = new Array();

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 区部・市部絞り込み
		searchKushibu: async function () {

			// 募集の種類、住宅の種別、入居人数がそれぞれ入力されている場合
			if (!co_isEmpty(this.form.jyutakuKind)
				&& !co_isEmpty(this.form.nyukyoNinzu)
				&& co_checkHalfNumber(this.form.nyukyoNinzu)) {

				let params = {
					'bosyuKind' : this.form.bosyuKind,
					'jyutakuKind' : this.form.jyutakuKind,
					'nyukyoNinzu' : this.form.nyukyoNinzu
				};
				let data = await co_post(PATH_BC005_GET_KUSHIBU, params);
				
				let kubuList = this.form.kubu.split(',');
				let selectKubuList = [];

				this.disp.kubuList = new Array();
				let kubu = data.kushibuList.filter(x => x.cdHanyo1 == '1');
				for (let i = 0; i < kubu.length; i++) {
					this.disp.kubuList.push(kubu[i].idCd);
					if (kubuList.indexOf(kubu[i].idCd) >= 0) {
						selectKubuList.push(kubu[i].idCd);
					}
				}

				// 区部の値を初期化する
				this.form.kubu = '';

				// 活性状態の区部が取得できなかった場合
				if (this.disp.kubuList.length == 0){
					this.disp.kubuList =[''];
					this.disp.kubuMsgFlg = true;
					this.disp.kubuZenSentaku = '';
					this.disp.kubuZenSentakuFlg = true;
				} else {
					if ( selectKubuList.length > 0 ) {
						this.form.kubu = selectKubuList.join(',');
					} 
					this.disp.kubuMsgFlg = false;
					this.disp.kubuZenSentakuFlg = false;

					// 区部の一括選択・解除チェックボックスの設定（活性部分が全てチェックされている場合にチェックする）
					let kubuList = this.disp.kubuList.join();
					if(kubuList == this.form.kubu){
						this.disp.kubuZenSentaku = '1';
					} else if ('1' == this.disp.kubuZenSentaku) {
						this.disp.kubuZenSentakuZikkouFlg = false;
						this.disp.kubuZenSentaku = '';
					}
				}

				let shibuList = this.form.shibu.split(',');
				let selectShibuList = [];

				this.disp.shibuList = new Array();
				let shibu = data.kushibuList.filter(x => x.cdHanyo1 == '2');
				for (let i = 0; i < shibu.length; i++) {
					this.disp.shibuList.push(shibu[i].idCd);
					if (shibuList.indexOf(shibu[i].idCd) >= 0) {
						selectShibuList.push(shibu[i].idCd);
					}
				}

				// 市部の値を初期化する
				this.form.shibu = '';

				// 活性状態の市部が取得できなかった場合
				if (this.disp.shibuList.length == 0){
					this.disp.shibuList = [''];
					this.disp.shibuMsgFlg = true;
					this.disp.shibuZenSentaku = '';
					this.disp.shibuZenSentakuFlg = true;
				} else {
					if ( selectShibuList.length > 0 ) {
						this.form.shibu = selectShibuList.join(',');
					} 
					this.disp.shibuMsgFlg = false;
					this.disp.shibuZenSentakuFlg = false;

					// 市部の一括選択・解除チェックボックスの設定（活性部分が全てチェックされている場合にチェックする）
					let shibuList = await this.disp.shibuList.join();
					if(shibuList == this.form.shibu){
						this.disp.shibuZenSentaku = '1';
					} else if ('1' == this.disp.shibuZenSentaku) {
						this.disp.shibuZenSentakuZikkouFlg = false;
						this.disp.shibuZenSentaku = '';
					}
				}
			}

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},

		// 選択値変更：区部
		changeKubu: function (val) {
			this.form.kubu = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：市部
		changeShibu: function (val) {
			this.form.shibu = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：主な交通機関のキーワードを含むリスト
		changeKeyword: function (val) {
			this.form.keyword = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：駅・バス停からの徒歩分
		changeTohoMin: function (val) {
			this.form.tohoMin = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：バス利用の住戸を除く
		changeBusJyogai: function (val) {
			this.form.busJyogai = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：間取り
		changeMadori: function (val) {
			this.form.madori = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：専用面積（上限）
		changeSenyoAreaFrom: function (val) {
			this.form.senyoAreaFrom = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：専用面積（下限）
		changeSenyoAreaTo: function (val) {
			this.form.senyoAreaTo = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：建設年度からの経過年数
		changeBuidYears: function (val) {
			this.form.buidYears = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：エレベーター
		changeElevator: function (val) {
			this.form.elevator = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：バリアフリー
		changeBarrierFree: function (val) {
			this.form.barrierFree = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：優遇抽せん
		changeYugu: function (val) {
			this.form.yugu = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},
		// 選択値変更：参考倍率
		changeBairitu: function (val) {
			this.form.bairitu = val;

			// 検索条件に該当する件数取得
			this.getSelectedCount();
		},

		// 検索ボタン押下
		clickSearchBtn: async function () {

			// 検索ボタン非活性
			this.disp.searchBtnDisabledFlg = true;

			// 検索該当件数の計算を実行しない
			this.disp.isClacSelectedCnt = false;

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);
			// 単項目チェック
			this.$refs.bosyuKind.validate();
			this.$refs.jyutakuKind.validate();
			this.$refs.nyukyoNinzu.validate();

			// アコーディオンを開く
			this.disp.isKubuOpen = true;
			this.disp.isShibuOpen = true;
			this.disp.isFilterOpen = true;
			if (this.disp.kbYuguDispFlg == false) {
				this.disp.kbYuguDispFlg = true;
				this.disp.kbYuguTempFlg = false;
			}

			await this.$nextTick();

			this.$refs.kubu.validate();
			this.$refs.shibu.validate();
			this.$refs.jyutakuName.validate();
			this.$refs.trans1.validate();
			this.$refs.trans2.validate();
			this.$refs.trans3.validate();
			this.$refs.keyword.validate();
			this.$refs.tohoMin.validate();
			this.$refs.busJyogai.validate();
			this.$refs.madori.validate();
			this.$refs.senyoAreaFrom.validate();
			this.$refs.senyoAreaTo.validate();
			this.$refs.buidYears.validate();
			this.$refs.elevator.validate();
			this.$refs.barrierFree.validate();
			this.$refs.yugu.validate();
			if (this.disp.bairituDispFlg) {
				this.$refs.bairitu.validate();
			}

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// 検索ボタン活性
				this.disp.searchBtnDisabledFlg = false;
				// 該当件数取得可
				this.disp.isClacSelectedCnt = true;
				return;
			}

			let inputError = false;

			// 専用面積大小チェック
			if (!co_isEmpty(this.form.senyoAreaFrom) && !co_isEmpty(this.form.senyoAreaTo)) {
				
				if (Number(this.form.senyoAreaFrom) > Number(this.form.senyoAreaTo)) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'senyoAreaInfo', msg: co_getMessage("E0012")});
					this.$refs.senyoAreaFrom.setError();
					this.$refs.senyoAreaTo.setError();
					if (!inputError) this.$refs.senyoAreaFrom.focus();
					inputError = true;
				}
			}

			// 入居予定人数チェック
			if (!co_isEmpty(this.form.nyukyoNinzu)) {

				if(this.form.nyukyoNinzu < 1 || this.form.nyukyoNinzu > 20) {
					// エラーメッセージ：E0063を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0063', '入居予定人数', '1人', '20人')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				} else {
					if (!co_isEmpty(this.form.jyutakuKind)) {
						this.checkNyukyoNinzu();
					} else {
						// 検索ボタン活性
						this.disp.searchBtnDisabledFlg = false;
						// 該当件数取得可
						this.disp.isClacSelectedCnt = true;
						return;
					}
				}
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				// 検索項目編集
				this.editSearchItem();

				// 検索処理実行
				this.doSearch();
			} else {
				// 入力チェックエラーが存在する場合
				// 該当件数取得可
				this.disp.isClacSelectedCnt = true;
			}

			// 検索ボタン活性
			this.disp.searchBtnDisabledFlg = false;
		},

		// 入居予定人数チェック 
		checkNyukyoNinzu: function () {

			let inputError = false;

			// 募集の種類（汎用コード1）
			let code = this.form.bosyuKind.substring(2);
			// 住宅の種別（単身向け）
			let kbZyutakuList_single = ['07', '08', '09', '11', '12', '14'];
			// 住宅の種別（シルバーピア）
			let kbZyutakuList_silverpier = ['10', '15'];
			// 住宅の種別（ポイント方式）
			let kbZyutakuList_point = ['20', '21'];

			// 募集の種類が「毎月募集」の場合
			if (code == 1) {
				// 住宅の種別が「単身者向住宅（抽せん方式）」以外かつ、入居人数が「2人未満」の場合
				if (this.form.jyutakuKind != '18' && this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0059')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
				// 住宅の種別が「単身者向住宅（抽せん方式）」かつ、入居人数が「2人以上」の場合
				if (this.form.jyutakuKind == '18' && this.form.nyukyoNinzu >= 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0061')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
			// 募集の種類が「定期募集（5月・11月）」の場合
			} else if (code == 2) {
				// 住宅の種別が「若年夫婦・子育て世帯（定期使用住宅）」かつ、入居人数が「2人未満」の場合
				if (this.form.jyutakuKind == '05' && this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0060')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
			// 募集の種類が「定期募集（8月・2月）」の場合
			} else if (code == 3) {
				// 住宅の種別が「居室内で病死等があった住宅（車いす使用者世帯向住宅・抽せん方式）」かつ、入居人数が「2人未満」の場合
				if (this.form.jyutakuKind == '13' && this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0060')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
				// 住宅の種別が「『単身者向』が付く住宅」かつ、入居人数が「2人以上」の場合
				if (kbZyutakuList_single.findIndex(item => item === this.form.jyutakuKind) >= 0
					&& this.form.nyukyoNinzu >= 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0061')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
				// 住宅の種別が「二人世帯向シルバーピア」かつ、入居人数が「2人未満」の場合
				if (kbZyutakuList_silverpier.findIndex(item => item === this.form.jyutakuKind) >= 0
					&& this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0062')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
				// 住宅の種別が「ポイント方式」が付く住宅かつ、入居人数が「2人未満」の場合
				if (kbZyutakuList_point.findIndex(item => item === this.form.jyutakuKind) >= 0
					&& this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0060')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
			// 募集の種類が「随時募集」の場合
			} else if (code == 4) {
				// 入居人数が「2人未満」の場合
				if (this.form.nyukyoNinzu < 2) {
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {id: 'nyukyoNinzuInfo', msg: co_getMessage('E0060')});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
			}
		},

		// 検索実行
		doSearch: async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let data =	await co_post(PATH_BC005_COUNT, this.form);
			let maxCount = this.$store.getters[STORE_ENV_GET_LIST_MAX_COUNT];

			// 取得件数が0件の場合
			if (data.listCount == null || data.listCount == 0) {
				// エラーメッセージ：E0014を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0014'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				// 該当件数取得可
				this.disp.isClacSelectedCnt = true;

				return;

			// 取得件数が最大件数を超えた場合
			} else if (data.listCount > maxCount)	{
				// エラーメッセージ：E0013を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0013', maxCount));
				
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				// 該当件数取得可
				this.disp.isClacSelectedCnt = true;

				return;
			}

			// 募集住宅一覧画面に渡すパラメータ取得
			this.form.hanyoCode = this.form.bosyuKind.substring(2);
			let list = this.disp.jyutakuDataList.filter(x => x.kbBosyuKbn == this.form.hanyoCode && x.kbZyutaku == this.form.jyutakuKind);
			this.form.zikoUmu = list[0].kbZiko;

			// 通常検索
			this.form.isAuthenticated = this.isAuthenticated;
			this.form.isOkiniiriSearch = false;

			// 募集住宅一覧画面に遷移
			this.transToBC006();
		},
		// お気に入り登録した住宅一覧へボタン押下
		clickOkiniiriSearchBtn: async function () {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// お気に入り登録件数取得
			let params = {
							kbBosyu: this.form.kbMosikomiStatus == '2' ? this.form.bosyuKind.substring(0, 2) : '',
							fgZuijiZyogai: this.form.kbMosikomiStatus != '0' ? '1' : '0',
							bosyuHoshiki: this.form.kbMosikomiStatus == '2' ? this.disp.bosyuHoshiki : '0',
						};

			let data =	await co_post(PATH_BC005_COUNT_OKINIIRI, params);
			
			// 取得件数が0件の場合
			if (data.listCount == null || data.listCount == 0) {
				// お気に入りなし未登録
				co_errorDialog(co_getMessage('E0132'), this.callBack);

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				return;
			} 

			// お気に入り検索
			this.form.isAuthenticated = this.isAuthenticated;
			this.form.isOkiniiriSearch = true;

			// 募集住宅一覧画面に遷移
			this.transToBC006();
		},
		// 検索条件に該当する件数取得処理
		getSelectedCount: async function () {

			// 検索ボタン押下時は該当件数取得を行わない
			if (false == this.disp.isClacSelectedCnt) {
				return;
			}

			let selectedCnt = 0;		// 必須検索条件の該当件数
			let naList = new Array();	// 任意検索条件による除外リスト

			// 募集の種類、住宅の種別、入居人数がそれぞれ入力されている場合
			if (!co_isEmpty(this.form.bosyuKind)
				&& !co_isEmpty(this.form.jyutakuKind)
				&& !co_isEmpty(this.form.nyukyoNinzu)
				&& co_checkHalfNumber(this.form.nyukyoNinzu)
				&& Number(this.form.nyukyoNinzu) > 0) {

				// 検索項目編集
				this.editSearchItem();

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// 件数取得
				// let data =	await co_post(PATH_BC005_COUNT, this.form);
				// if (data.listCount != null) {
				// 	selectedCnt = data.listCount;
				// }

				// 該当件数絞り込み用住宅リストが未設定の場合、必須検索条件に合致する住宅を検索
				if (this.disp.jyutakuList.length == 0) {

					let self = this;
					let listData = await co_post(PATH_BC005_GET_JYUTAKUINFO, this.form, function (res, handle) {

						if (res.status == HTTP_STATUS.OK) {
							return handle(res);
						} else {
							// ローディング表示終了
							self.$store.commit(STORE_VIEW_PROGRESS, false);
						}
					});

					if (listData == null || listData.jyutakuList.length == 0 ) {

						// ローディング表示終了
						this.$store.commit(STORE_VIEW_PROGRESS, false);

						// 該当件数ゼロを設定
						this.disp.selectedCnt = 0;
						return;
					}

					this.disp.jyutakuList = listData.jyutakuList;
				}

				// 専用面積（下限）が専用面積（上限）より大きい場合は該当件数ゼロを設定
				if (!co_isEmpty(this.form.senyoAreaFrom) && !co_isEmpty(this.form.senyoAreaTo)) {
					if (Number(this.form.senyoAreaFrom) > Number(this.form.senyoAreaTo)) {
						// ローディング表示終了
						this.$store.commit(STORE_VIEW_PROGRESS, false);

						// 該当件数ゼロを設定
						this.disp.selectedCnt = 0;
						return;
					}
				}

				// 建設年度からの経過年数（年度のみ）
				let nmBuidYears = 0;
				if (!co_isEmpty(this.form.buidYears)) {
					nmBuidYears = Number(this.form.buidYears.substring(1));
				}

				// 検索条件による絞り込み
				let targetList = this.disp.jyutakuList;
				selectedCnt = targetList.length;
				for (let i = 0; i < targetList.length; i++) {

					let target = targetList[i];

					// 区部市部
					if (this.form.kushicyoList.length > 0
							&& this.form.kushicyoList.findIndex(item => item == target.cdKusicyoson) < 0) {
						// 選択した区部市部に合致しない住宅は除外
						naList.push(i);
					}

					// 住宅名
					if (!co_isEmpty(this.form.jyutakuName)
							&& target.txJyutakuname.indexOf(this.form.jyutakuName) < 0) {
						// 入力した住宅名を含まない住宅は除外
						naList.push(i);
					}

					// 主な交通機関
					if (this.form.transList.length > 0) {
						let isMatch = false;
						if ('1' == this.form.keyword) {
							// いずれかのキーワードを含む
							isMatch = false;
							for (let j = 0; j < this.form.transList.length; j++) {
								if (target.txTrans.indexOf(this.form.transList[j]) >= 0) {
									isMatch = true;
									break;
								}
							}
						} else {
							// すべてのキーワードを含む
							isMatch = true;
							for (let j = 0; j < this.form.transList.length; j++) {
								if (target.txTrans.indexOf(this.form.transList[j]) < 0) {
									isMatch = false;
									break;
								}
							}
						}

						// 入力した主な交通機関を含まない住宅は除外
						if (!isMatch) {
							naList.push(i);
						}
					}

					// 駅・バス停からの徒歩分
					if (!co_isEmpty(this.form.tohoMin)
							&& target.kbToho > this.form.tohoMin) {
						// 入力した徒歩分を超える住宅は除外
						naList.push(i);
					}

					// バス利用の住戸を除く
					if (!co_isEmpty(this.form.busJyogai)
							&& '1' == this.form.busJyogai
							&& '2' != target.fgBusriyou) {
						// バス利用ありは除外
						naList.push(i);
					}

					// 間取り
					if (this.form.madoriList.length > 0
						&& this.form.madoriList.findIndex(item => item == target.cdMadori1) < 0
						&& this.form.madoriList.findIndex(item => item == target.cdMadori2) < 0
						&& this.form.madoriList.findIndex(item => item == target.cdMadori3) < 0) {
							// 選択した間取りに合致しない住宅は除外
							naList.push(i);
					}

					// 専用面積
					let isSenyoMatch = false;
					if (!co_isEmpty(this.form.senyoAreaFrom) && !co_isEmpty(this.form.senyoAreaTo)
							&& target.nuSenyoUpr >= Number(this.form.senyoAreaFrom)
							&& target.nuSenyoLow <= Number(this.form.senyoAreaTo)) {
						isSenyoMatch = true;
					}

					// 選択された専用面積範囲と合致する専用面積でない住宅は除外
					if (!isSenyoMatch) {
						naList.push(i);
					}

					// 建設年度からの経過年数
					if (!co_isEmpty(this.form.buidYears)) {
						if ('0' == this.form.buildYearsCd) {
							if (target.nuTikunensu > nmBuidYears) {
								// 選択した経過年数が「XX以内」の場合、選択した経過年数以上の住宅は除外
								naList.push(i);
							}
						} else {
							if (target.nuTikunensu < nmBuidYears) {
								// 選択した経過年数が「XX以上」の場合、選択した経過年数以下の住宅は除外
								naList.push(i);
							}
						}
					}

					// エレベーター
					if (!co_isEmpty(this.form.elevator)
							&& target.fgElevator != ( '00' + this.form.elevator ).slice( -2 )) {
						// エレベーターなしは除外
						naList.push(i);
					}

					// バリアフリー
					if (!co_isEmpty(this.form.barrierFree)
							&& target.fgBarrierfree != this.form.barrierFree) {
						// バリアフリー仕様なしは除外
						naList.push(i);
					}

					// 優遇抽せん
					if (this.form.yuguList.length > 0
						&& this.form.yuguList.findIndex(item => item == target.kbYugu) < 0) {
							// 選択した優遇抽せん内容に合致しない住宅は除外
							naList.push(i);
					}

					// 参考倍率
					if (!co_isEmpty(this.form.bairitu)
							&& (co_isEmpty(target.nuBairitu)
							|| Number(this.form.bairitu) < target.nuBairitu)) {
						// 参考倍率未設定の場合は除外
						// 選択した参考倍率よりも大きい参考倍率は除外
						naList.push(i);
					}

				}

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
			}

			// 除外列Indexの重複削除
			let newNaList = naList.filter((element, index) => naList.indexOf(element) === index);

			// 該当件数設定（必須検索条件の該当件数 － 任意検索条件による除外件数）
			this.disp.selectedCnt = selectedCnt - newNaList.length;
		},
		// 募集方式判定
		getBosyuHoshiki: function (code) {

			let kbZyutaku_M = ['01', '02', '03', '17', '18', '24'];
			let kbZyutaku_P = ['20', '21'];
			let kbZyutaku_Z = ['22', '23'];

			if (kbZyutaku_M.findIndex(item => item === code) >= 0) {
				return '1';
			} else if (kbZyutaku_P.findIndex(item => item === code) >= 0) {
				return '3';
			} else if (kbZyutaku_Z.findIndex(item => item === code) >= 0) {
				return '4';
			} else {
				return '2';
			}
		},
		// 募集住宅一覧画面遷移
		transToBC006 : function () {

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC005', data: this.form });
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC005DISP', data: this.disp });

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// ページング情報クリア
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);

			// 募集住宅一覧画面に遷移
			let param = {
							paramData : this.form,
							bosyuHoshiki : this.disp.bosyuHoshiki
						};
			co_toTrans('BC006', param);
		},
		// 検索項目編集
		editSearchItem : function() {
			// 建設年度からの経過年数コード設定
			if (!co_isEmpty(this.form.buidYears)) {
				this.form.buildYearsCd = this.form.buidYears.substring(0,1);
			}

			// 区市町コード設定
			let kushicyoCd = '';
			if (!co_isEmpty(this.form.kubu)) {
				if (!co_isEmpty(this.form.shibu)) {
					kushicyoCd = this.form.kubu + ',' + this.form.shibu;
				} else {
					kushicyoCd = this.form.kubu;
				}
			} else if(!co_isEmpty(this.form.shibu))	{
				kushicyoCd = this.form.shibu;
			}
			this.form.kushicyoList = new Array();

			if (!co_isEmpty(kushicyoCd)) {
				this.form.kushicyoList = kushicyoCd.split(',');
			}

			// 間取り項目設定
			this.form.madoriList = new Array();
			if (!co_isEmpty(this.form.madori)) {
				this.form.madoriList = this.form.madori.split(',');
			}

			// 主な交通機関項目設定
			this.form.transList = new Array();
			if (!co_isEmpty(this.form.trans1)) {
				this.form.transList.push(this.form.trans1);
			}
			if (!co_isEmpty(this.form.trans2)) {
				this.form.transList.push(this.form.trans2);
			}
			if (!co_isEmpty(this.form.trans3)) {
				this.form.transList.push(this.form.trans3);
			}

			// 優遇抽せんの有無設定
			this.form.yuguList = new Array();
			if (!co_isEmpty(this.form.yugu)) {
				this.form.yuguList = this.form.yugu.split(',');
			}
		}
	}
};
</script>

<style scoped>
.kaigyousinai{
	display: inline-block;
}

.div-right {
	text-align: right;
	font-size: 16px;
	margin-bottom: 5px;
}

.div-tyuimargin {
	margin-top: 10px;
	margin-left: 2%;
	margin-right: 2%;
	margin-bottom: 15px;
	padding-bottom: 0px !important;
}

.toroku-tyui {
	width: auto;
	color: #ff0000;
}

.square-position{
	padding-right: 20px;
}

.width-filter-title {
	background-color: #cdcdcd !important;
	padding-top: 3px;
	padding-bottom: 3px;
	margin-left: 20px;
	height: 40px;
}

.contents__filter--title {
	padding: 2px 20px 2px 0 !important;
	border-bottom: 1px dashed #aaa;
	width: 94% !important;
}

.contents__favorite {
	margin-bottom: 9px;
}

/** 該当件数 */
.contents__counterbar {
	position: fixed;
	bottom: 0;
	background-color: #000000;
	height: 80px;
	z-index: 800;
	background-color: rgba(0, 0, 0, 0.7);
}

.contents__counterbar dl {
	padding-top: 17px;
}

.contents__counterbar dt {
	color: #ffffff;
    display: inline-block;
    font-weight: bold;
}
.contents__counterbar dd {
	color: #ffffff;
    display: inline-block;
    font-weight: bold;
	vertical-align: middle;
}

.contents__counterbar--counter {
	background: #ffffff;
    color: #ff0000;
    font-weight: bold;
    display: inline-block;
    line-height: 1.2;
    vertical-align: bottom;
	margin: 0 15px;
	text-align: right;
    padding: 7px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.isMOBILE-non-display{
		display: none;
	}

	.contents__div--joukenyouken{
		font-size: 16px;
	}

	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}

	.contents__hissu {
		right: 1%;
	}
	
	/* 募集の種類 */
	.width-bosyu {
		width: auto;
	}

	.width-jyutaku {
		width: auto;
		max-width: 100%;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}

	/* 入居予定人数 */
	.nyukyo-title {
		background-color: #fdfdfd;
	}
	.width-nyukyo {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 3%;
		text-align: right;
		margin-right: 7px;
	}

	/* 住宅名 */
	.width-jyutakuname-title {
		margin: 10px 20px;
		background-color: #f1f2f5;
	}
	.jyutakuname-title {
		margin-left: 20px !important;
	}
	.width-jyutakuname {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 50%;
	}

	/* 区市町 */
	.width-kushicho-title {
		background-color: #fdfdfd !important;
		border-top: 1px dashed #aaa;
	}
	.width-kubu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-bottom: 5px;
		margin-left: 15px;
	}
	.width-shibu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-left: 15px;
	}
	.width-kubu{
		font-size: 16px;
	}
	.width-shibu{
		font-size: 16px;
	}

	/* 主な交通機関 */
	.width-trans-title {
		border-bottom: none !important;
	}
	.width-trans-item {
		margin-left: 20px;
	}
	.width-trans1 {
		width: 30%;
	}
	.width-trans2 {
		width: 30%;
		margin-left: 8px;
	}
	.width-trans3 {
		width: 30%;
		margin-left: 8px;
	}
	.width-trans-tyui {
		margin-left: 20px;
	}

	/* 徒歩時間 */
	.width-tohomin-title {
		margin-top: 10px;
		margin-left: 20px;
	}
	.width-tohomin {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		margin-left: 10px;
	}
	/* キーワード */
	.width-keyword {
		margin-top: -18px;
		margin-bottom: -10px;
		margin-left: 20px;
	}
	/* バス利用除外 */
	.width-busJyogai-title {
		font-size: 16px;
		margin-left: 5px;
	}

	/* 間取り */
	.width-madori-item {
		margin-left: 20px;
	}
	.width-madori {
		font-size: 16px;
	}
	.width-madori-tyui {
		margin-left: 20px;
	}

	/* 専用面積 */
	.width-senyoarea-title {
		font-size: 16px;
	}
	.width-senyoarea-item {
		margin-left: 20px;
	}
	.width-senyoarea {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}
	.width-buildyears {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}

	/* エレベーター */
	.width-elevator {
		font-size: 16px;
		margin-left: -18px;
	}
	.width-elevaotr-tyui {
		margin-left: 16px;
	}

	/* バリアフリー */
	.width-barrierfree-item {
		margin-left: 0px;
	}
	.width-barrierfree {
		font-size: 16px;
		margin-left: -18px;
	}

	/* 優遇抽せんの有無 */
	.width-yugu {
		font-size: 16px;
		margin-left: -18px;
	}

	/* 参考倍率 */
	.width-bairitu-item {
		margin-left: 20px;
		margin-bottom: 10px;
	}
	.width-bairitu {
		width: auto;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}
	.width-bairitu-tyui {
		margin-left: 20px;
	}
	.height-bairitu-tyui {
		line-height: 1.3em;
	}

	/* 検索ボタン */
	.search-button {
		text-align: center;
	}

	/* 募集の種類注意文 */
	.bosyu-message {
		margin-left: 20px;
		margin-bottom: -3px;
	}

	/* フォントサイズ */
	.font-size {
		font-size: 16px !important;
	}

	/* 前回募集の応募倍率 */
	.margin-zenBairituTyui {
		margin-left: 20px;
	}

	/* 区部市部の全選択全解除 */
	.margin__left--select-all {
		margin-left: 55px;
	}

	/** 該当件数 */
	.contents__counterbar {
		font-size: 120%;
		width: 1080px;
	}

	.contents__counterbar dl {
		text-align: center;
	}

	.contents__counterbar--counter {
		font-size: 120%;
		width: 100px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.isPC-non-display{
		display: none;
	}

	.square-position2{
		padding-top: 2px;
	}

	.contents__div--joukenyouken{
		font-size: 18px;
	}

	.contents__div--joukenmargin{
		margin-top: 13px;
		line-height: 1.5em;
	}

	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}

	/* 募集の種類 */
    .bosyu-title {
        margin-bottom: -22px;
    }
    .width-bosyu {
        width: 90%;
		height: 38px;
    }

    .width-jyutaku {
        width: 90%;
		height: 38px;
    }

    /* 入居予定人数 */
    .nyukyo-title {
		background-color: #fdfdfd;
		height: 40px;
		margin-bottom: -22px;
    }
    .width-nyukyo {
        font-size: 18px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 8%;
		text-align: right;
		margin-right: 7px;
    }

    /* 住宅名 */
    .width-jyutakuname-title {
        font-size: 18px;
		background-color: #f1f2f5;
		text-align: left;
		margin-bottom: -22px;
    }
	.jyutakuname-title {
		margin-left: 5px !important;
	}
    .width-jyutakuname {
        font-size: 18px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 90%;
    }

    /* 区市町 */
    .width-kushicho-title {
        background-color: #fdfdfd !important;
		border-top: 1px dashed #aaa;
    }
    .width-kubu-title {
        background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-bottom: 5px;
		margin-left: 15px;
    }
    .width-shibu-title {
        background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-left: 15px;
    }
	.width-kubu {
		font-size: 18px;
	}
	.width-shibu {
		font-size: 18px;
	}

	/* .width-filter-title {
		background-color: #cdcdcd !important;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-left: 20px;
		height: 40px;
	} */

    /* 主な交通機関 */
    .width-trans-title {
		font-size: 18px;
		margin-bottom: -15px;
		border-bottom: none !important;
	}
	.width-trans-item {
		margin-left: 5px;
	}
    .width-trans1 {
		width: 90%;
	}
	.width-trans2 {
		width: 90%;
		margin-top: 5px;
	}
	.width-trans3 {
		width: 90%;
		margin-top: 5px;
	}
	.width-trans-tyui {
		margin-top: 10px;
		margin-left: 5px;
		margin-bottom: -20px;
		line-height: 22px;
	}

	/* 徒歩時間 */
	.width-tohomin-title {
		margin-left: 5px;
	}
	.width-tohomin {
		font-size: 18px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		height: auto;
	}

	/* キーワード */
	.width-keyword {
		margin-top: 5px;
	}

	/* バス利用除外 */
	.width-busJyogai-title {
		font-size: 18px;
		margin-top: 5px;
		margin-left: -10px;
	}

    /* 間取り */
	.width-madori-item {
		margin-left: -10px;
	}
    .width-madori {
        font-size: 18px;
    }
	.width-madori-tyui {
		margin-left: 5px;
	}

    /* 専用面積 */
    .width-senyoarea-title {
        font-size: 18px;
		margin-bottom: -15px;
    }
	.width-senyoarea-item {
		margin-left: 5px;
	}
    .width-senyoarea {
        font-size: 18px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		height: auto;
		margin-bottom: -20px;
    }
    .width-buildyears {
		font-size: 18px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		height: auto;
        text-align: left;
		margin-left: -18px;
		margin-bottom: -22px;
    }

    /* エレベーター */
    .elevator-title {
		margin-bottom: -22px;
    }
    .width-elevator {
        font-size: 18px;
		margin-left: -30px;
    }
	.width-elevaotr-tyui {
		margin-left: 5px;
	}

    /* バリアフリー */
    .barrierfree-title {
		margin-bottom: -22px;
    }
	.width-barrierfree-item {
		margin-left: -10px;
	}
    .width-barrierfree {
        font-size: 18px;
    }

    /* 優遇抽せんの有無 */
    .yugu-title {
		margin-bottom: -22px;
    }
    .width-yugu {
        font-size: 18px;
		margin-left: -30px;
    }

    /* 参考倍率 */
    .bairitu-title {
		margin-bottom: -22px;
    }
	.width-bairitu-item {
		margin-left: 0px;
	}
    .width-bairitu {
        font-size: 18px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
		height: auto;
    }
	.width-bairitu-tyui {
		margin-left: 5px;
	}

	.width-zenBairituTyui {
		padding-top: 0px;
		padding-bottom: 15px;
		/* margin-left: -20px; */
	}

	/* 検索ボタン */
	.search-button {
		text-align: center;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	/* 募集の種類注意文 */
	.bosyu-message {
		margin-left: 20px;
		margin-bottom: -3px;
	}

	/* フォントサイズ */
	.font-size {
		font-size: 18px !important;
	}

	.contents__filter--title {
		padding: 2px 20px 2px 0 !important;
		border-bottom: 1px dashed #aaa;
	}

	/* 区部市部の全選択全解除 */
	.margin__left--select-all {
		margin-left: 27px;
	}

	/* お気に入り検索ボタン */
	.favorite-button {
		margin-top: 10px;
	}

	/** 該当件数 */
	.contents__counterbar {
		font-size: 110%;
		width: 100%;
	}

	.contents__counterbar dl {
		text-align: left;
		padding-left: 2%;
	}

	.contents__counterbar--counter {
		font-size: 110%;
		width: 80px;
		margin: 0 11px;
	}
}

/* 検索条件部の表示・非表示 */
@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.open-enter-active {
	animation: open .2s;
}
.open-leave-active {
	animation: open .2s linear reverse;
}
.filter {
	margin-top: 1px;
}

</style>